import React from 'react';
import { Row } from 'antd';

import Item from './Item';

import './index.less';

export default ({ section, type, image, image_title, image_alt, title, content, items }) => {
  const children = [];
  let countItens = 0;
  for (const item of items) {
    children.push(<Item index={countItens}  {...{ type, ...item }} />);
    countItens++
  }

  let listLayout = (
    <div className='styles_section container'>
      <div className=" styles_container__2h91Y">
        <div className='styles_container_2z'>
          <div className="listing__wrap">
            <h1>{title}</h1>
          </div>
          <ul className={`listing__${type}`}>
            {children}
          </ul>
        </div>
      </div>
    </div>
  );

  if (type === 'listing_itens') {
    listLayout = (
      <div className='styles_section container'>
        <div className='styles_container_2z'>
          <ul className={`listing__${type}`}>
            {children}
          </ul>
        </div>
      </div>
    );
  } else if (type === 'OTHER-CUSTOM-TYPE-HERE') {
    listLayout = (
      <Row className={`listing__${type}`}>
        {children}
      </Row>
    );
  }

  return (
    <section className="listing has-bottom-divider">
      {listLayout}
    </section>
  );
}
